// extracted by mini-css-extract-plugin
export var orderSummary = "_px-0";
export var showMoreLessButton = "_px-1";